import { CutIcon } from '~/st-doc-viewer/page-groups/page-group-divider'
import type { DocumentViewerMessage } from '@st/document-viewer-kit'
import { Button, Spinner } from '@st/theme'
import { useSelect, useProcess } from '~/store'
import { PageGroupList } from '~/st-doc-viewer/page-groups/page-group-list'
import { ViewerSidebarContent, ViewerSidebarTabs } from '~/st-doc-viewer/sidebar-layout'
import { selBundleEditing } from './selection'

export function BundledDocumentSidebar({
  sendViewerMessage
}: {
  sendViewerMessage: (message: DocumentViewerMessage) => void
}) {
  const folder = useProcess('stFolder')
  const view = useSelect('stFolder', selBundleEditing)
  return (
    <ViewerSidebarContent
      tabs={
        <ViewerSidebarTabs
          tabs={[{ id: 'documents', label: 'Documents in Bundle' }]}
          selected="documents"
          onSelect={() => {}}
        />
      }
      footer={
        <div className="flex justify-end">
          <Button
            variant="primary"
            disabled={view.phase !== 'ready'}
            leadingIcon={view.phase === 'extracting' && <Spinner className="size-4" />}
            onClick={() =>
              folder.send({ type: 'bundleExtractionRequested', ranges: view.selectedRanges })
            }
          >
            Extract selected
          </Button>
        </div>
      }
    >
      <p className="p-3 text-xs leading-relaxed text-stone-500">
        Select documents to extract.
        <br />
        Use{' '}
        <span role="img" aria-label="scissors">
          <CutIcon className="inline-block size-3.5 align-[-2px]" />
        </span>{' '}
        between pages to split or combine.
      </p>
      <PageGroupList
        groups={view.groups}
        sendViewerMessage={sendViewerMessage}
        renderGroup={(_, index) => {
          const { range, selected, extracted } = view.rows[index]
          return {
            selected,
            description: extracted && (
              <span>
                Extracted as{' '}
                <button
                  type="button"
                  className="relative z-10 text-left text-blue-600 underline decoration-blue-200 underline-offset-2 hover:decoration-blue-600"
                  onClick={() =>
                    folder.send({
                      type: 'navigationRequested',
                      request: { documentId: extracted.id, target: { type: 'document' } }
                    })
                  }
                >
                  {extracted.name}
                </button>
              </span>
            ),
            onToggleSelected: () => folder.send({ type: 'bundleSelectionToggled', range })
          }
        }}
      />
    </ViewerSidebarContent>
  )
}
